/**
 * 专栏
 * 专栏API
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import ColumnContentBaseVo from './ColumnContentBaseVo';




  /**
   * The ColumnContentDetailVo model module.
   * @module column/model/ColumnContentDetailVo
   * @version 0.1.0
   */

  /**
   * Constructs a new <code>ColumnContentDetailVo</code>.
   * @alias module:column/model/ColumnContentDetailVo
   * @class
   * @param id {Integer} id
   * @param columnId {Integer} 所属专栏ID
   * @param title {String} 内容标题
   * @param contentType {Integer} 内容类型 0:文件夹 1:视频 2:音频 3:AI问答链接 4:虚拟仿真地址 5:PPT 6:其他
   */
  var exports = function(id, columnId, title, contentType) {
    var _this = this;

    _this['id'] = id;
    _this['columnId'] = columnId;

    _this['title'] = title;
    _this['contentType'] = contentType;













  };

  /**
   * Constructs a <code>ColumnContentDetailVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:column/model/ColumnContentDetailVo} obj Optional instance to populate.
   * @return {module:column/model/ColumnContentDetailVo} The populated <code>ColumnContentDetailVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'columnId')) {
        obj['columnId'] = ApiClient.convertToType(data['columnId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'folderId')) {
        obj['folderId'] = ApiClient.convertToType(data['folderId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contentType')) {
        obj['contentType'] = ApiClient.convertToType(data['contentType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contentUri')) {
        obj['contentUri'] = ApiClient.convertToType(data['contentUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contentUrl')) {
        obj['contentUrl'] = ApiClient.convertToType(data['contentUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'detailContent')) {
        obj['detailContent'] = ApiClient.convertToType(data['detailContent'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUri')) {
        obj['thumbUri'] = ApiClient.convertToType(data['thumbUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUrl')) {
        obj['thumbUrl'] = ApiClient.convertToType(data['thumbUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'freeTrial')) {
        obj['freeTrial'] = ApiClient.convertToType(data['freeTrial'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'createAccountId')) {
        obj['createAccountId'] = ApiClient.convertToType(data['createAccountId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'modifyAccountId')) {
        obj['modifyAccountId'] = ApiClient.convertToType(data['modifyAccountId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contentList')) {
        obj['contentList'] = ApiClient.convertToType(data['contentList'], [ColumnContentBaseVo]);
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 所属专栏ID
   * @member {Integer} columnId
   */
  exports.prototype['columnId'] = undefined;
  /**
   * 所属文件夹ID
   * @member {Integer} folderId
   */
  exports.prototype['folderId'] = undefined;
  /**
   * 内容标题
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 内容类型 0:文件夹 1:视频 2:音频 3:AI问答链接 4:虚拟仿真地址 5:PPT 6:其他
   * @member {Integer} contentType
   */
  exports.prototype['contentType'] = undefined;
  /**
   * 资源链接/地址URI（选填）
   * @member {String} contentUri
   */
  exports.prototype['contentUri'] = undefined;
  /**
   * 资源链接/地址URL（选填）
   * @member {String} contentUrl
   */
  exports.prototype['contentUrl'] = undefined;
  /**
   * 内容简介  （只有当contentType!=0时有效）
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 详细介绍（html） （只有当contentType!=0时有效）
   * @member {String} detailContent
   */
  exports.prototype['detailContent'] = undefined;
  /**
   * 预览图URI （只有当contentType!=0时有效）
   * @member {String} thumbUri
   */
  exports.prototype['thumbUri'] = undefined;
  /**
   * 预览图URL （只有当contentType!=0时有效）
   * @member {String} thumbUrl
   */
  exports.prototype['thumbUrl'] = undefined;
  /**
   * 是否试看/听 true:免费/试看 false:不免费 （只有当contentType!=0时有效）
   * @member {Boolean} freeTrial
   */
  exports.prototype['freeTrial'] = undefined;
  /**
   * 排序
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 更新时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;
  /**
   * 创建者ID
   * @member {Integer} createAccountId
   */
  exports.prototype['createAccountId'] = undefined;
  /**
   * 最后修改者ID
   * @member {Integer} modifyAccountId
   */
  exports.prototype['modifyAccountId'] = undefined;
  /**
   * 下级内容（只有当contentType==0时有效）
   * @member {Array.<module:column/model/ColumnContentBaseVo>} contentList
   */
  exports.prototype['contentList'] = undefined;



  export default exports;
;


